import { Injectable } from '@angular/core';
import { IWallet, ISmartRouterWallet, WalletValidationSmartRes, SmartRoutingQualifiedProviderResponse } from '../../model/models/agent/wallet.interface';
import { APP_CONFIG } from '../../environment';
import { HttpProvider } from '../../providers/http/http';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { WALLET_FIELDS } from '../../providers/myria/app-variables';
import { TranslateService } from '@ngx-translate/core';
import { LoggerEvent, LoggerProvider } from '../../providers/logger/logger';
import { VirtualPaymentType } from '../../model/types/vpa-type';
import { FeatureFlagTypes, UtilsProvider } from '../myria/utils-provider';
import { IOrder } from 'model/models/order/order-interface';
import { ErrorCodeType } from '../../model/types/error-code-type';

@Injectable()
export class MobileWalletProvider {
  walletRes: { walletList: ISmartRouterWallet[], currencyFrom: string, currencyTo: string, countryTo: string };
  walletValidationRes: { validators: any, agentToId: number, agentToLocId: number };
  walletValidationSmartRes: WalletValidationSmartRes;
  useSmartWalletRouting: boolean;
  walletFetchError: any;

  constructor(public http: HttpClient,
    private httpProvider: HttpProvider,
    private sanitizer: DomSanitizer,
    private translate: TranslateService,
    private utilsProvider: UtilsProvider) {
  }

  getMobileWalletFields(countryTo: string, agentToId: number, agentToLocId: number, benId: number): Promise<any> {
    const params = {
      CountryToCode: countryTo,
      AgentToId: agentToId,
      AgentToLocId: agentToLocId,
      BeneficiaryId: benId
    }
    return this.httpProvider.post(APP_CONFIG.API_URL + 'api/MobileWallet/RequiredFields', params);
  }


  async getMobileWallets(order, forceNoSmartRouting?: boolean): Promise<ISmartRouterWallet[]> {
    this.walletFetchError = null;

    const entitySearchParams = {
      CountryTo: order.countryTo,
      CurrencyTo: order.currencyTo,
      CurrencyFrom: order.currencyFrom
    }
  const isSmartRouterEnabledParams = {
    ...entitySearchParams,
    AmountFrom: order.amountFrom,
    AmountTo: order.amountTo
  };
    if (forceNoSmartRouting) {
      this.useSmartWalletRouting = false;
      LoggerProvider.info(this, "Forcing not to use smart routing for Send Again");
    }
    else {
      await this.isSmartRoutingEnable(isSmartRouterEnabledParams);
    }
    if (this.walletRes && this.walletRes.countryTo == order.countryTo && this.walletRes.currencyFrom == order.currencyFrom && this.walletRes.currencyTo == order.currencyTo) {
      if (this.useSmartWalletRouting && this.walletRes.walletList[0] && !this.walletRes.walletList[0].EntityName)
        LoggerProvider.info(this, "Smart routing is enabled but walletList is from old flow");
      else if (!this.useSmartWalletRouting && this.walletRes.walletList[0] && !this.walletRes.walletList[0].Name)
        LoggerProvider.info(this, "Smart routing is disabled but walletList is from smart routing");
      else {
        LoggerProvider.info(this, "Using cached wallet list");
        return this.walletRes.walletList;
      }
    }
    var wallets: ISmartRouterWallet[];
    if (this.useSmartWalletRouting) {
      LoggerProvider.info(this, "Using smart routing for wallets")
      var walletRes;
      const defaultLogoPath = "assets/imgs/default-wallet.png";
      try {
        walletRes = await this.httpProvider.post(`${APP_CONFIG.API_URL}api/MobileWallet/entitysearch`, entitySearchParams);
      }
      catch (ex) {
        this.walletFetchError = ex;
        LoggerProvider.error(this, LoggerEvent.ProviderException, "Failed to fetch wallets from entity search", ex)
      }
      if (walletRes && walletRes.EntityList) {
        wallets = walletRes.EntityList;
        wallets.map(async wallet => {
          const logoPath = wallet.LogoPathCDN ? wallet.LogoPathCDN.trim() : '';
          if (logoPath) {
            try {
              wallet.logo = this.sanitizer.bypassSecurityTrustUrl(logoPath);
            } catch (error) {
              LoggerProvider.error(this, LoggerEvent.ProviderException, "Failed to load logo for smart wallet " + wallet.EntityName, error)
              wallet.logo = defaultLogoPath;
            }
          }
          else {
            wallet.logo = defaultLogoPath;
          }
        });
      }
    }
    else {
      LoggerProvider.info(this, "Using legacy endpoints for wallets")
      try {
        walletRes = await this.httpProvider.get(`${APP_CONFIG.API_URL}api/MobileWallet/Wallets`, { CountryTo: order.countryTo, CurrencyTo: order.currencyTo, CurrencyFrom: order.currencyFrom });
      }
      catch (ex) {
        this.walletFetchError = ex;
        LoggerProvider.error(this, LoggerEvent.ProviderException, "Failed to fetch wallets from Wallets endpoint", ex)
      }
      if (walletRes && walletRes.Wallets) {
        wallets = walletRes.Wallets;
        wallets.map(async wallet => {
          let imageBlob: Blob;
          imageBlob = await this.http.get(APP_CONFIG.remittanceApiBaseUrl + 'agent/logo/' + wallet.AggregatorId + '?useMobile=true&agentToLocId=' + wallet.WalletId + '&deliveryMethod=34', { responseType: 'blob' }).toPromise();
          let objectURL = URL.createObjectURL(imageBlob);
          wallet.logo = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        }
        );
      }
    }

    if (wallets && wallets.length > 0) {
      wallets.forEach(wallet => {
        var key;
        if (wallet.EntityName) {
          wallet['value'] = wallet.EntityName
          key = 'mobileWalletDescriptions.description_' + wallet.EntityID;
        }
        else if (wallet.Name) {
          wallet['value'] = wallet.Name
          key = 'mobileWalletDescriptions.description_' + wallet.WalletId;
        }
        const description = APP_CONFIG.contentConfigs[key];
        if (description && description.indexOf(key) === -1)
          wallet.description = description;
      });
    }

    this.walletRes = {
      walletList: wallets,
      countryTo: order.countryTo,
      currencyFrom: order.currencyFrom,
      currencyTo: order.currencyTo
    }
    return this.walletRes.walletList;
  }

  validateWalletNumberFormat(phonePrefix: string, phoneNumber: string, countryTo: string, agentTo: number, agentToLocId: number): Promise<any> {
    const data = {
      "CountryPhoneCode": phonePrefix,
      "MobileWalletAccountNo": phoneNumber,
      "CountryToCode": countryTo,
      "AgentToId": agentTo,
      "AgentToLocId": agentToLocId
    }
    return this.httpProvider.post(APP_CONFIG.API_URL + 'api/MobileWallet/ApplyFormattingRules', data);
  }


  /// need to get the format to do the checking number format
  validateWalletSmartRoutingNumberFormat(phonePrefix: string, phoneNumber: string, countryTo: string, entityId: number, hashcodeToken): Promise<any> {
    const data = {
      "CountryPhoneCode": phonePrefix,
      "MobileWalletAccountNo": phoneNumber,
      "CountryTo": countryTo,
      "EntityId": entityId,
      "HashcodeToken": hashcodeToken
    }
    return this.httpProvider.post(APP_CONFIG.API_URL + 'api/MobileWallet/ApplySmartRoutingFormattingRules', data);
  }

  validateMobileWallet(amountTo: number, walletAccount: string, benId: number, agentId: number, currencyTo: string, agentLocId: number, fields: any[] | null, debitCard = false): Promise<any> {
    const data = {
      AmountTo: amountTo,
      MobileWalletAccountNo: walletAccount,
      BeneficiaryId: benId,
      AgentId: agentId,
      DepositCurrency: currencyTo,
      AgentLocId: agentLocId,
      Fields: fields,
      DebitCard: debitCard
    };

    return this.httpProvider.post(APP_CONFIG.API_URL + 'api/MobileWallet/Validate', data);

  }

  validateMobileWalletv2(amountTo: number, walletAccount: string, providerId: number, entityId: number, currencyTo: string, bankId: number, fields: any[] | null, debitCard = false, benId: number, correspondentId: number, correspondentLocId: number): Promise<any> {
    const data = {
      AmountTo: amountTo,
      MobileWalletAccountNo: walletAccount,
      providerId: providerId,
      EntityId: entityId,
      DepositCurrency: currencyTo,
      bankId: bankId,
      //Fields: fields,
      //DebitCard: debitCard
      VirtualPaymentType: VirtualPaymentType.SmartRouting,
      BeneficiaryId: benId,
      AgentId: correspondentId,
      AgentLocId: correspondentLocId,
    };

    return this.httpProvider.post(APP_CONFIG.API_URL + 'api/MobileWallet/Validate/v2', data);

  }

  // to be deprecated in favor of smart routing wallets
  getWalletAccountValidations(order, agentToId: number, agentToLocId: number): Promise<any> {
    if (this.walletValidationRes && this.walletValidationRes.agentToId === agentToId && this.walletValidationRes.agentToLocId === agentToLocId)
      return this.walletValidationRes.validators;
    return new Promise(async (resolve, reject) => {
      try {
        const recipientFields = await this.getWalletFields(order, agentToId, agentToLocId);
        const walletField = recipientFields.formData.RecipientSendMoneyForm.formFields.find(field => field.id === 'MobileWalletAccountNo');
        if (!walletField) {
          // The wallet field is dropped when an order restriction blocks this agent and location for the route
          throw { errorCode: ErrorCodeType.DeliveryMethodNotAvailable, errorMessage: `No wallet field returned for agent ${agentToId}/${agentToLocId} to ${order.countryTo} - route restricted` };
        }
        walletField.validators.isMobileWalletAccountNumberFreeText = recipientFields.isMobileWalletAccountNumberFreeText;
        walletField.validators.isMobileWalletCountryCodeRemove = recipientFields.isMobileWalletCountryCodeRemove;
        this.walletValidationRes = {
          validators: walletField.validators,
          agentToId,
          agentToLocId
        };
        resolve(walletField.validators);
      } catch (ex) {
        reject(ex)
      }
    });
  }

  getWalletAccountSmartRoutingValidations(order, entityId: number): Promise<any> {
    if (this.walletValidationRes && this.walletValidationSmartRes.entityId === entityId)
      return this.walletValidationRes.validators;

    return new Promise(async (resolve, reject) => {
      try {
        const smartWalletResponse = await this.getSmartRoutingWalletFields(order, entityId);
        var smartWalletFields;
        if (smartWalletResponse && smartWalletResponse.Value && smartWalletResponse.Value as SmartRoutingQualifiedProviderResponse)
          smartWalletFields = smartWalletResponse.Value
        else
          throw new Error('Issue in structure response of qualified providers');

        var provider, hashcodeToken;
        if (smartWalletFields && smartWalletFields.Providers && smartWalletFields.Providers.length > 0) // or find by some condition if needed
          provider = smartWalletFields.Providers[0];
        if (smartWalletFields && smartWalletFields.Providers && smartWalletFields.Providers.length > 1)
          LoggerProvider.info(this, "Got multiple providers from qualifed providers")
        if (!provider) {
          throw { errorCode: ErrorCodeType.DeliveryMethodNotAvailable, errorMessage: `No qualified provider for entity ${entityId} to ${order.countryTo} - route restricted` };
        }
        if (smartWalletResponse && smartWalletResponse.Result && smartWalletResponse.Result.RetVal) {
          if (smartWalletResponse.Result.RetVal == 1 && smartWalletResponse.Result.RetMsg) {
            LoggerProvider.info(this, "Got smart routing response from qualified providers");
            providerId = provider.MapId;
            hashcodeToken = smartWalletResponse.Result.RetMsg;

          }
          else if (smartWalletResponse.Result.RetVal == 3 && smartWalletResponse.Result.RetMsg) {
            LoggerProvider.info(this, "Got legacy response from qualified provider")
            providerId = provider.CorrespondentLocId;
            hashcodeToken = smartWalletResponse.Result.RetMsg;
          }
          else
            throw new Error('Error in qualified providers response');
        }
        else
            throw new Error('Error in qualified providers response');


        var providerId;
        const walletField = smartWalletFields.RequiredFields.find(field => field.FieldName === "Mobile Number");
        var entitySetting;
        if (smartWalletFields && smartWalletFields.EntitySettings && smartWalletFields.EntitySettings.length > 0)
          entitySetting = smartWalletFields.EntitySettings[0];
        if (!walletField || !entitySetting) {
          throw new Error('Invalid data: Required field or entity settings not found');
        }
        // the wallet's own account format, so order/validate doesn't fall back to the recipient's bank format
        const accountFormat = smartWalletFields.AccountFormats && smartWalletFields.AccountFormats.length > 0
          ? smartWalletFields.AccountFormats[0]
          : null;
        this.walletValidationSmartRes = {
          requiredFields: walletField,
          entitySetting: entitySetting,
          entityId,
          correspondentId: provider.CorrespondentId,
          correspondentLocId: provider.CorrespondentLocId,
          providerId,
          hashcodeToken,
          accountFormatId: accountFormat ? accountFormat.Id : null
        };
        resolve(this.walletValidationSmartRes);
      } catch (ex) {
        reject(ex);
      }
    });
  }

  getSmartRoutingWalletFields(order, entityId: number): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const params: any = {
          bankId: entityId,
          countryTo: order.countryTo,
          currencyFrom: order.currencyFrom,
          currencyTo: order.currencyTo,
          amountFrom: order.amountFrom,
          amountTo: order.amountTo,
          deliveryMethod: 34
        };
        const recipientFields = await this.httpProvider.post(`${APP_CONFIG.API_URL}api/mobilewallet/qualifiedproviders`, params);
        // for testing mock data
        // const recipientFields = await this.httpProvider.post(`${APP_CONFIG.API_URL}api/mobilewallet/qps`, params);

        resolve(recipientFields);
      } catch (ex) {
        reject(ex)
      }
    });
  }

  async isSmartRoutingEnable(params: any): Promise<boolean> {
    try {
      var featureFlag = UtilsProvider.getFeatureFlagDataUnsafe(FeatureFlagTypes.UsingSmartRouting)
      if (!featureFlag) {
        LoggerProvider.info(this, "Smart routing feature flag is disabled");
        this.useSmartWalletRouting = false;
        return (false);
      }
      this.useSmartWalletRouting = await this.httpProvider.post(`${APP_CONFIG.API_URL}api/MobileWallet/IsSmartRoutingEnabled`, params);
      LoggerProvider.info(this, "Smart routing endpoint value is : " + this.useSmartWalletRouting);
      return this.useSmartWalletRouting;
    } catch (ex) {
      LoggerProvider.error(this, LoggerEvent.ProviderException, "Error when fetching is smartrouting enabled " + ex);
      return (null)
    }
  }

  getWalletFields(order, agentToId: number, agentToLocId: number): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
          const params: any = {
            CountryTo: order.countryTo,
            CurrencyTo: order.currencyTo,
            RecipientId: order.recipient.id,
            AgentToId: agentToId,
            AgentToLocationId: agentToLocId,
            AmountFrom: order.amountFrom,
            DeliveryMethod: order.deliveryMethodInternal,
            AmountTo: order.amountTo,
            ShouldCalcAmountFrom: order.amountTo ? order.shouldCalcAmountFrom : false
          };
          const recipientFields = await this.httpProvider.get(`${APP_CONFIG.remittanceApiBaseUrl}recipient/sendmoneyfields`, params);

          resolve(recipientFields);
      } catch (ex) {
        reject(ex)
      }
    });
  }

  getWalletSelectionParams(countryTo, itemsPromise: any) {
    const favoritePromise = itemsPromise.then((wallets = []) => {
      let favorites: any = null;
      const walletIds = {}
        wallets.forEach(wallet => {
          if (wallet.EntityID)
            walletIds[wallet.EntityID] = wallet;
          else
            walletIds[wallet.WalletId] = wallet;
        });
        let favKey = 'mobileWalletFavorites.walletIds_To_' + countryTo;
        let favs = APP_CONFIG.contentConfigs[favKey];
        if (!favs) {
          favKey = 'mobileWalletFavorites.walletIds';
          favs = APP_CONFIG.contentConfigs[favKey];
        }
        if (favs) {
          const orderIds = favs.split(',');
          favorites = [];
          for (const id of orderIds) {
            const wallet = walletIds[id.trim()];
            if (wallet)
              favorites.push(wallet);
          }
        }
      return favorites;
    });
    var itemFieldText;
    if (this.useSmartWalletRouting)
      itemFieldText = 'EntityName'
    else
      itemFieldText = 'Name'

    itemFieldText
    return {
      header: this.translate.instant('page.sendMoneyPaymentPage.eWalletTitle'),
      newDesign: true,
      useIcons: true,
      itemFieldText: itemFieldText,
      itemFieldImage: true,
      itemFieldDescription: 'description',
      itemsPromise,
      favoritePromise,
      hideSearchbar: true,
      hideHelp: true,
      showFavoritesOnlyOnce: true,
      isFromWallet: true
    };
  }

  getProviderInfo(country) {
    const data = {
      country,
      cardTypeId: 122110 // TODO: might change in the future when more card types are used than Visa Direct
    }
    return this.httpProvider.post(APP_CONFIG.API_URL + 'api/MobileWallet/ProviderInfo', data);
  }

  logout() {
    this.walletFetchError = null;
    this.walletRes = null;
    this.walletValidationRes = null;
    this.walletValidationSmartRes = null;
    this.useSmartWalletRouting = null;
  }
}


// WEBPACK FOOTER //
// ./src/providers/mobile-wallet/mobile-wallet-provider.ts